import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const adsRoutes: RouteObject[] = [
  {
    path: 'anuncios',
    element: <ModuleRoute module="ads" permission="ads:read" />,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('./campaigns')).CampaignsListPage }) },
      { path: 'conectar', lazy: async () => ({ Component: (await import('./connect')).ConnectAdsPage }) },
      { path: 'nova', lazy: async () => ({ Component: (await import('./new-campaign')).NewCampaignPage }) },
      { path: ':id', lazy: async () => ({ Component: (await import('./campaigns')).CampaignDetailPage }) },
    ],
  },
];
